export default __webpack_public_path__ + "static/media/submitted_elite.504006fb.gif";